import {
  ADD_TO_CART,
  REMOVE_FROM_CART,
  INCREASE_QUANTITY,
  DECREASE_QUANTITY,
} from "../action/actionTypes";

const initialState = {
  cartItems: [],
};

const cartReducer = (state = initialState, action) => {
  // Handle invalid state scenarios
  let actualState = state;

  // 1. Handle legacy array format
  if (Array.isArray(actualState)) {
    actualState = { cartItems: actualState };
  }

  // 2. Handle missing cartItems property
  if (!actualState?.cartItems) {
    actualState = initialState;
  }

  switch (action.type) {
    case ADD_TO_CART:
      const existingItem = actualState.cartItems.find(
        (item) => item.id === action.payload.id
      );

      if (existingItem) {
        return {
          ...actualState,
          cartItems: actualState.cartItems.map((item) =>
            item.id === action.payload.id
              ? {
                  ...item,
                  quantity:
                    (item.quantity || 1) + (action.payload.quantity || 1),
                }
              : item
          ),
        };
      }

      return {
        ...actualState,
        cartItems: [
          ...actualState.cartItems,
          {
            ...action.payload,
            quantity: action.payload.quantity || 1,
          },
        ],
      };

    case REMOVE_FROM_CART:
      return {
        ...actualState,
        cartItems: actualState.cartItems.filter(
          (item) => item.id !== action.payload
        ),
      };

    case INCREASE_QUANTITY:
      return {
        ...actualState,
        cartItems: actualState.cartItems.map((item) =>
          item.id === action.payload
            ? { ...item, quantity: (item.quantity || 1) + 1 }
            : item
        ),
      };

    case DECREASE_QUANTITY:
      return {
        ...actualState,
        cartItems: actualState.cartItems.map((item) =>
          item.id === action.payload && item.quantity > 1
            ? { ...item, quantity: item.quantity - 1 }
            : item
        ),
      };
    default:
      return actualState;
  }
};

export default cartReducer;
